'use client';

import { FC, ReactNode } from 'react';

import { useInitializeTranslations } from '@telialt/common-cms/src/useTranslations';

import { ProductDetailsSkeleton } from '../ProductDetailsSkeleton/ProductDetailsSkeleton';

// ToDo: possible to combine (TranslationsInit, CartInitClientSide, UserDataInit) to single ProductPageInitializer
export const TranslationsInit: FC<{ children?: ReactNode }> = ({ children }) => {
    const { t } = useInitializeTranslations();

    if (!t) {
        return <ProductDetailsSkeleton />;
    }

    return <>{children}</>;
};
